import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Astronomy = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M9.194 26.214c0 .5-.4.9-.9.9H6.393v1.901c0 .5-.4.9-.9.9-.501 0-.901-.4-.901-.9v-1.8H2.79c-.5 0-.9-.4-.9-.901 0-.5.4-.9.9-.9h1.8v-1.802c0-.5.4-.9.901-.9.5 0 .9.4.9.9v1.802h1.801c.5-.1 1.001.3 1.001.8ZM40.21 3.702c0 .5-.4.9-.9.9h-1.801v1.801c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.8h-1.802c-.5 0-.9-.4-.9-.901 0-.5.4-.9.9-.9h1.801V.9c-.1-.5.3-.9.8-.9s.901.4.901.9v1.801h1.8c.501 0 1.002.4 1.002 1.001ZM42.111 32.417c0 .5-.4.9-.9.9h-1.8v1.802c0 .5-.401.9-.901.9s-.9-.4-.9-.9v-1.801h-1.802c-.5 0-.9-.4-.9-.9 0-.501.4-.901.9-.901h1.801v-1.801c0-.5.4-.9.9-.9s.901.4.901.9v1.8h1.801c.5 0 .9.4.9.901Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m40.81 14.508-3.501-.9.2-1.001c.1-.5-.2-1-.7-1.1L16.098 6.102l.4-1.5c.1-.5-.2-1.001-.7-1.101L9.593 1.9c-.5-.1-1 .2-1.1.7l-.4 1.401c-5.704.3-7.605 7.904-2.802 11.006l-.3 1.3c-.1.5.2 1.001.7 1.101l6.203 1.601c.5.1 1.001-.2 1.101-.7l.4-1.501L21 18.81l-9.805 23.813c-.2.5 0 1 .5 1.2.5.2 1 0 1.201-.5l9.105-22.112 9.105 22.212c.2.5.7.7 1.2.5.5-.2.7-.7.5-1.2L23.303 19.51l10.805 2.802c.5.1 1-.2 1.1-.7l.2-1.001 3.403.9c.5.1 1-.2 1.1-.7l1.401-5.203c.3-.5 0-1-.5-1.1ZM4.593 8.905c.4-1.501 1.6-2.702 3.101-3.002l-1.9 7.104c-1.101-1-1.602-2.501-1.201-4.102Zm6.803 8.104-4.402-1.1 3.101-12.007 4.403 1.1-3.102 12.007Zm22.312 3.202-19.91-5.103 1.8-7.204 19.911 5.103-1.801 7.204Zm4.803-.7-2.502-.701.9-3.402 2.502.7-.9 3.402Z"
  })));
});
Astronomy.displayName = 'Astronomy';
Astronomy.defaultProps = {
  'aria-label': 'Astronomy'
};
export default Astronomy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Astronomy.js
// module id = 3607
// module chunks = 11